import * as React from "react";
import {cx} from "emotion";

import {cs} from "@Common/react/chain-services";

import {AddressListsModal} from "./address-lists-modal/address-lists-modal";
import { consumeContext } from "@Common/react/context";

// Types.Xpresso.Account.Office.AddressBookRoute.ComponentPropsAddressListSection
export const AddressListsSection = ({next}) => cs(
    consumeContext("session"),
    ({session}) => next({
        isLoading: false,
        render: ({className}) => cs(
            ["modal", (_, next) => AddressListsModal({next})],
            ({modal}) => (
                <div key="address-lists" className={cx(className)}>
                    <div className="header">
                        <div className="title">Manage Address Lists</div>
                        <div {...{
                            className: "edit",
                            onClick: () => modal.show({officeId: session.value?.branchId}),
                            "xd-qa-type": "link",
                            "xd-qa-name": "Manage Address Lists",
                        }}>
                            Edit
                        </div>
                    </div>
                </div>
            ),
        )
    }),
);
